import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { Link } from 'react-router-dom';
import React from 'react';
import { motion } from 'framer-motion';

const AboutUsSection = () => {
	return (
		<section className='py-20 bg-gradient-to-br from-gray-50 via-white to-gray-100'>
			<div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
				<div className='max-w-4xl mx-auto text-center'>
					{/* Content */}
					<motion.div
						initial={{ opacity: 0, y: 30 }}
						whileInView={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.8, ease: 'easeOut' }}
						viewport={{ once: true }}
						className='space-y-8'
					>
						<div className='space-y-4'>
							<motion.h2
								initial={{ opacity: 0, y: 30 }}
								whileInView={{ opacity: 1, y: 0 }}
								transition={{ delay: 0.3, duration: 0.8 }}
								viewport={{ once: true }}
								className='font-playfair font-bold leading-tight mb-12 max-w-5xl mx-auto text-center'
							>
								<div className='relative'>
									<span className='block mb-6 text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-black text-primary relative'>
										Realize Effective Legal Representation and Advisory
										<div className='absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-gradient-to-r from-primary to-accent rounded-full'></div>
									</span>
								</div>
							</motion.h2>
						</div>

						<motion.div
							initial={{ opacity: 0, y: 20 }}
							whileInView={{ opacity: 1, y: 0 }}
							transition={{ delay: 0.4, duration: 0.8 }}
							viewport={{ once: true }}
							className='space-y-6'
						>
							<p className='font-source text-lg text-text-secondary leading-relaxed'>
								We are an experienced team of attorneys and solicitors with a proven record of
								diligence to proffer productive legal advice with cost-effective approach to meet
								the needs of our clients. We timeously deliver our professional services to clients
								without missing out on necessary details.
							</p>

							<p className='font-source text-lg text-text-secondary leading-relaxed'>
								Our practice areas includes but not limited to Commercial law & Debt Recovery,
								Intellectual property law, Energy and Natural Resources, Property law practice,
								Family law, Medical Law, Corporate law, Labour/Industrial and employment, Litigation
								& Alternative Dispute Resolution (ADR), Space law, International investment law,
								Renewable Energy law, Global governance law and international relation tax law,
								Corporate governance...
							</p>
						</motion.div>

						<motion.div
							initial={{ opacity: 0, y: 30 }}
							whileInView={{ opacity: 1, y: 0 }}
							transition={{ delay: 0.7, duration: 0.8 }}
							viewport={{ once: true }}
							className='flex flex-col sm:flex-row gap-4 pt-4 justify-center'
						>
							<Link to='/about'>
								<Button
									variant='default'
									className='bg-primary hover:bg-primary/90 text-white font-source font-bold px-8 py-3 text-base shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105'
									iconName='ArrowRight'
									iconPosition='right'
									iconSize={18}
								>
									Learn More About Us
								</Button>
							</Link>
						</motion.div>
					</motion.div>
				</div>
			</div>
		</section>
	);
};

export default AboutUsSection;
